<app-dialog-header *ngIf="this.dataDialog.isDialog" label="Avisos" i18n-label></app-dialog-header>
<app-avisosconf-table> </app-avisosconf-table> 
